// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"a562ec9b","573":"616c4d0d","803":"79e7e11f"}[chunkId] + ".chunk.js";
};